import type {MetricNodeType} from './metric-node/types';
import type {PureTextNodeType} from './pure-text-node/types';
import type {StickyNoteNodeType} from './sticky-note-node/types';
import type {TextNodeType} from './text-node/types';

export type AppNode = MetricNodeType | TextNodeType | StickyNoteNodeType | PureTextNodeType;

export function isMetricNode(node: AppNode): node is MetricNodeType {
  return node.type === `metric`;
}

export function isTextNode(node: AppNode): node is TextNodeType {
  return node.type === `text`;
}

export function isStickyNoteNode(node: AppNode): node is StickyNoteNodeType {
  return node.type === `stickyNote`;
}

export function isPureTextNode(node: AppNode): node is PureTextNodeType {
  return node.type === `pureText`;
}
